import { proxy } from 'valtio';
import { deepClone } from 'valtio/utils';

import { DiagramComment } from 'models';

type CommentState = {
    newComment: DiagramComment | null;
    newCommentLoading: boolean;
    preview: DiagramComment['id'] | null;
    canvas: DiagramComment['id'] | null;
    sidebar: DiagramComment['id'] | null;
};

const commentStateDefaults: CommentState = {
    newComment: null,
    newCommentLoading: false,
    preview: null,
    canvas: null,
    sidebar: null,
};

const state = proxy(deepClone(commentStateDefaults));

export { state, commentStateDefaults };
